import { BillingGroup } from "@clockwise/schema";

export enum SuggestedOrgInviteReason {
  AttendSameMeetings = "AttendSameMeetings",
  OrganizedYourMeetings = "OrganizedYourMeetings",
  OnYourTeam = "OnYourTeam",
  MeetsWithYourTeammates = "MeetsWithYourTeammates",
}

export enum SearchPersonStatusResponse {
  NonUser = "NonUser",
  Invited = "Invited",
  User = "User",
  Deactivated = "Deactivated",
}

export enum SortType {
  FullName = "FullName",
  Status = "Status",
  Subscription = "Subscription",
  SignUpDate = "SignUpDate",
  Role = "Role",
}

export enum SortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum BillingGroupRoleEnum {
  Admin = "Admin",
  Member = "Member",
  None = "None",
}

export type MemberPerson = {
  targetCalendarId: string;
  givenName: string;
  familyName: string;
  externalImageUrl: string;
  isSuggested: boolean;
  numberOfSharedMeetings: number;
  numberOfOrganizedMeetings: number;
  inviteReason: SuggestedOrgInviteReason;
  recentlySent: boolean;
  totalScore: number;
  status: SearchPersonStatusResponse;
  billingGroup?: BillingGroup;
  signUpMillis: number;
  userId?: string;
  personId: string;
  role: BillingGroupRoleEnum;
  isYou: boolean;
  recentlyRequested?: boolean;
};
